
import React, { PropTypes } from 'react';
import classnames from 'classnames';

import './style.scss';
import Link from 'components/Link';

const SubNavigationItem = props => {
  const { isForForum, isForSearch, isForMagazine, ...otherProps } = props;
  const className = classnames('SubNavigationItem', {
    'is-for-forum': isForForum,
    'is-for-search': isForSearch,
    'is-for-magazine': isForMagazine
  });

  return (
    <div className={className}>
      <Link {...otherProps} activeClassName="is-active" />
    </div>
  );
};

SubNavigationItem.propTypes = {
  isForForum: PropTypes.bool,
  isForSearch: PropTypes.bool,
  isForMagazine: PropTypes.bool
};

export default SubNavigationItem;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/SubNavigation/SubNavigationItem/index.js
 **/